import Mutations from "./document-mutations";
import Actions from "./document-actions";
import Getters from "./document-getters";
const store = {
  namespaced: true,
  state: {
    classifications: {
      byApplication: {}
    },
    documents: {
      byApplication: {}
    },
    comments: {
      byApplication: {}
    },
    sampleDocuments: {
      byId: {}
    },
    documentRequests: {
      byId: {}
    }
  },
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default store;